<div class="mr">
  <!-- The message this report is about -->
  <header class="mr__head">
    <div class="mr__head-top">
      <p class="bk-eyebrow">Message report</p>
      <a class="mr__crumb" [routerLink]="reportsLink">
        <span class="bk-sym" aria-hidden="true">arrow_back</span>
        All sends
      </a>
    </div>
    <h2 class="bk-heading mr__title">{{ subject }}</h2>
    @if (copy) {
      <p class="mr__copy"><bk-sms-text [text]="copy" [inline]="true" /></p>
    }
    <p class="mr__meta">
      @if (message?.from) {
        <span>from {{ message?.from }}</span>
      }
      @if (scheduleOptions.length) {
        <span>{{ scheduleOptions.length === 1 ? "1 send" : formatCount(scheduleOptions.length) + " sends" }}</span>
      }
    </p>
  </header>

  <!-- How the chosen send went -->
  @if (table.scheduleUuid) {
    <section class="bk-panel mr__outcome" aria-labelledby="mr-outcome">
      <header class="mr__outcome-head">
        <h3 class="bk-eyebrow" id="mr-outcome">This send</h3>
        @if (selectedWhen) {
          <span class="mr__note">{{ selectedWhen }}</span>
        }
      </header>

      @switch (outcomeState) {
        @case ("loading") {
          <div class="mr__skel" role="status">
            <span class="bk-sr-only">Loading delivery</span>
            <span class="bk-skel" style="width: 120px; height: 34px" aria-hidden="true"></span>
            <span class="bk-skel" style="width: 100%; height: 6px" aria-hidden="true"></span>
          </div>
        }
        @case ("error") {
          <div class="mr__retry">
            <p class="mr__quiet">
              Delivery receipts for this send could not be loaded. Check your connection and try again.
            </p>
            <button type="button" class="bk-btn bk-btn--ghost" (click)="retryOutcome()">Try again</button>
          </div>
        }
        @case ("ready") {
          @if (outcome && outcome.total > 0) {
            <div class="mr__lead">
              <span class="mr__share">{{ share }}</span>
              <span class="mr__share-label">{{ outcome.inFlight > 0 ? "delivered so far" : "delivered" }}</span>
              @if (outcome.failed > 0) {
                <button
                  type="button"
                  class="mr__failed"
                  [attr.aria-label]="'Show the ' + formatCount(outcome.failed) + ' failed recipients'"
                  [attr.aria-pressed]="table.filter === 'failed'"
                  (click)="showFailed()"
                >
                  {{ formatCount(outcome.failed) }} failed
                  <span class="bk-sym" aria-hidden="true">filter_alt</span>
                </button>
              } @else {
                <span class="mr__of">of {{ formatCount(outcome.total) }}</span>
              }
            </div>
            <div class="mr__bar" role="img" [attr.aria-label]="outcomeBreakdown">
              <span class="mr__seg mr__seg--ok" [style.flex-grow]="outcome.delivered"></span>
              @if (outcome.failed > 0) {
                <span class="mr__seg mr__seg--bad" [style.flex-grow]="outcome.failed"></span>
              }
              <span class="mr__seg mr__seg--wait" [style.flex-grow]="outcome.inFlight"></span>
            </div>
          } @else {
            <p class="mr__quiet">
              No delivery receipts for this send yet. They usually start arriving a few
              minutes after it goes out.
            </p>
          }
        }
      }
    </section>
  }

  @if (sendsState === "error") {
    <p class="mr__quiet mr__notice">
      The list of sends could not be loaded, so every recipient of this message is shown.
    </p>
  }

  <!-- Who it reached -->
  <app-campaign-report-details-table
    tableTitle="Recipients"
    [miniTable]="false"
    [tableOptions]="scheduleOptions"
    [selectedOption]="table.scheduleUuid"
    [tableData]="table.rows"
    [loading]="table.loading || sendsState === 'loading'"
    [selectedSort]="arrangementSort"
    [statusFilter]="table.filter"
    [currentPage]="table.page"
    [totalPages]="table.totalPages"
    [totalItems]="table.total"
    [pageSize]="table.size"
    [filtered]="table.filtered"
    [exportable]="true"
    [exporting]="table.exporting"
    [exportNote]="table.exportNote"
    [exportFailed]="table.exportFailed"
    (search)="updateSearchTerm($event)"
    (sort)="updateSortArrangementCriteria($event)"
    (scheduleChange)="updateMessageSchedule($event)"
    (statusChange)="updateStatusFilter($event)"
    (changePage)="table.setPage($event)"
    (pageSizeChange)="table.setSize($event)"
    (export)="downloadCsv()"
  ></app-campaign-report-details-table>

  @if (table.failed) {
    <div class="mr__retry mr__notice" role="alert">
      <p class="mr__quiet">Recipients could not be loaded. Check your connection and try again.</p>
      <button type="button" class="bk-btn bk-btn--ghost" (click)="table.load()">Try again</button>
    </div>
  }

  <!-- Who the message went to -->
  <section class="mr__charts" aria-label="Audience breakdown">
    @if (loadingCharts && !messageCharts) {
      <span class="bk-skel mr__chart-skel mr__chart--wide" aria-hidden="true"></span>
      <span class="bk-skel mr__chart-skel" aria-hidden="true"></span>
      <span class="bk-skel mr__chart-skel" aria-hidden="true"></span>
    } @else {
      <div class="mr__chart mr__chart--wide">
        <app-delivery-rate-by-recipients-graph
          [graphData]="messageCharts?.deliveryRateByGroupReport || []"
        ></app-delivery-rate-by-recipients-graph>
      </div>
      <div class="mr__chart">
        <app-gender-distribution-graph
          [graphData]="messageCharts?.genderDistributionPieReport ?? null"
        ></app-gender-distribution-graph>
      </div>
      <div class="mr__chart">
        <app-age-group-distribution-graph
          [graphData]="messageCharts?.ageDistributionPieReport ?? null"
        ></app-age-group-distribution-graph>
      </div>
    }
  </section>
</div>
